import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    IPackage,
    ODataResponse,
} from '@models';
import { FileUploadService } from '@services/file.upload.service';
import { ODataQueryOptions } from '@services/generics/odata.query';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';

import { Observable } from 'rxjs';

@Injectable()
export class PackageService extends ODataService<IPackage, string> {
    protected _endpoint = 'odata/Processes';
    constructor(
        http: HttpClient,
        private _fileUploadService: FileUploadService,
    ) {
        super(http, MapperService.packageMap);

    }

    public getVersions(packageId?: string, queryOptions?: ODataQueryOptions): Observable<ODataResponse<IPackage>> {
        return this.get(queryOptions, `/odata/Processes/UiPath.Server.Configuration.OData.GetProcessVersions(processId='${packageId}')`);
    }

    public uploadPackages(files: File[]) {
        return this._fileUploadService.uploadFiles(files, '/odata/Processes/UiPath.Server.Configuration.OData.UploadPackage()');
    }

    public downloadLink(entry: IPackage) {
        return `${this._endpoint}/UiPath.Server.Configuration.OData.DownloadPackage(key='${entry.key}')`;
    }

    public download(packageKey: string): Observable<ArrayBuffer> {
        const url = `${this._endpoint}/UiPath.Server.Configuration.OData.DownloadPackage(key='${packageKey}')`;

        return this._http.get(url, { headers: {'content-type': 'application/octet-stream' }, responseType: 'arraybuffer' });
    }
}
